import { t } from 'i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Container, Heading, Paragraph } from '@treams/treams-ui';

import ConfigurationField from '../fields/ConfigurationField';
import { FieldContainer } from '../ProductConfiguration';
import { Header } from '../ProductLayout';
import ProductTile from '../ProductTile';

export default function Slack() {
	const { data, loading } = graphql.useSlackConfigQuery();
	const [consume] = graphql.useSlackConsumeOAuth2CodeMutation();
	const [autoLink] = graphql.useAutoLinkSlackIdentitiesMutation();

	const field: graphql.ConnectorConfigField | undefined = data
		? {
				__typename: 'ConnectorConfigFieldOAuth2',
				id: 'auth',
				key: 'auth',
				type: graphql.ConnectorConfigFieldType.Oauth2,
				isDangerous: false,
				isConfigured: !!data.viewer.workspace.slackConfig?.team,
				authorizeUrl: data?.viewer.workspace.slackConfig?.authorizeUrl!,
				authorizationInfo: data.viewer.workspace.slackConfig?.team?.name,
			}
		: undefined;

	return (
		<Container py={4}>
			<Header
				mb={3}
				style={{
					backgroundImage: `url('https://assets.ontreams.com/marketplace/slack-wide.jpg')`,
					backgroundPosition: 'top center',
				}}
			/>
			<Flex mb={3} alignItems="center">
				<Heading flexGrow={1} flexShrink={1}>
					{t(`connectors.product.slack.title`)}
				</Heading>
				<Paragraph>{t('settings.connectors.marketplace.price.free')}</Paragraph>
			</Flex>
			<Box mb={3}>
				<Paragraph>De beschrijving wordt binnenkort toegevoegd.</Paragraph>
			</Box>

			{loading || !field ? (
				<FieldContainer.Skeleton />
			) : (
				<FieldContainer
					field={field!}
					translate={() => {
						return {
							title: 'Koppelen met Slack',
							description:
								'Om te verbinden met Slack, moet je inloggen via de onderstaande button. Je wordt doorverwezen naar de site van Slack en krijgt daarna een scherm te zien met een overzicht van de gegevens die je gaat delen. Vervolgens kun je hier akkoord op geven.',
						};
					}}
				>
					<ConfigurationField
						onSave={async (value) => {
							if (!value.textValue) {
								return;
							}

							await consume({
								variables: {
									input: {
										code: value.textValue,
									},
								},
							});

							await autoLink();
						}}
						field={field}
					/>
				</FieldContainer>
			)}
		</Container>
	);
}

export function SlackTile(props: { selected: boolean }) {
	return (
		<ProductTile
			id="slack"
			title="Slack"
			description="Great teamwork starts with a digital HQ"
			logoImageURL="https://assets.ontreams.com/marketplace/slack.png"
			selected={props.selected}
			price={0}
		/>
	);
}
